import React, { useState, useEffect } from 'react'
import Button from '@mui/material/Button'
import Checkbox from '@mui/material/Checkbox'
import CheckIcon from '@mui/icons-material/Check'
import CloseIcon from '@mui/icons-material/Close'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogContentText from '@mui/material/DialogContentText'
import DialogTitle from '@mui/material/DialogTitle'
import FormControl from '@mui/material/FormControl'
import FormControlLabel from '@mui/material/FormControlLabel'
import FormGroup from '@mui/material/FormGroup'
import Grid from '@mui/material/Grid'
import IconButton from '@mui/material/IconButton'
import InputLabel from '@mui/material/InputLabel'
import ListSubheader from '@mui/material/ListSubheader'
import MenuItem from '@mui/material/MenuItem'
import Paper from '@mui/material/Paper'
import Select from '@mui/material/Select'
import Table from '@mui/material/Table'
import TableBody from '@mui/material/TableBody'
import TableContainer from '@mui/material/TableContainer'
import TableCell from '@mui/material/TableCell'
import TableHead from '@mui/material/TableHead'
import TableRow from '@mui/material/TableRow'
import TextField from '@mui/material/TextField'
import Typography from '@mui/material/Typography'
import {
    processFirstWordsText,
    processLastWordsText,
    processFirstWordsAfterFirstNumberOfWordsText,
    processFirstWordsAfterLastNumberOfWordsText,
    processFirstWordsBeforeOccurence,
    processRegularExpressionText,
    processDateExpression,
    getNewOutputFormat
} from './Extractors'

function SourcePropertiesWizard(props) {
    const [tabData, setTabData] = useState([])
    const [externalTabData, setExternalTabData] = useState([])
    const [open, setOpen] = useState(false)
    const [selectedElement, setSelectedElement] = useState({ "id": -2, "type": -2, "segmentName": "", "ranges": [], "outputFormat": [] })
    const [selectedRangeIndex, setSelectedRangeIndex] = useState(-1)
    const [previewData, setPreviewData] = useState([])
    const [extractorType, setExtractorType] = useState('NONE')
    const [numberOfWords, setNumberOfWords] = useState(1)
    const [after, setAfter] = useState(1)
    const [inverse, setInverse] = useState(false)
    const [occurrence, setOccurrence] = useState('')
    const [regularExpressionTerm, setRegularExpressionTerm] = useState('')
    const [regularExpressionOutput, setRegularExpressionOutput] = useState('')
    const [dateExtractorType, setDateExtractorType] = useState(0)
    const [tableHasHeader, setTableHasHeader] = useState(false)
    const [currentTab, setCurrentTab] = useState(0)
    const [factsColumnRanges, setFactsColumnRanges] = useState([])

    // trigger on component mount
    useEffect(() => {
        setTabData(props.previewData)
        setExternalTabData(props.externalTabData)
        setSelectedElement(props.selectedElement)
        setSelectedRangeIndex(props.selectedRangeIndex)
        setTableHasHeader(props.tableHasHeader)
        setCurrentTab(props.currentTab)
        setFactsColumnRanges(props.factsColumnRanges)
        getRowData(props.selectedRangeIndex, props.selectedElement, props.previewData, 1, 'NONE', false, 1, '', '', '', 0, props.tableHasHeader, props.currentTab, props.factsColumnRanges)
    }, [])

    useEffect(() => {
        if (props.open !== open) {
            setOpen(props.open)
        }
    }, [props.open])

    useEffect(() => {
        if (selectedElement.id !== props.selectedElement.id || selectedElement.segmentName !== props.selectedElement.segmentName) {
            let finalExtractionType = null
            if (props.selectedElement.ranges[selectedRangeIndex] === undefined || props.selectedElement.ranges[selectedRangeIndex] === null) {
                finalExtractionType = resetExtraction()
            } else {
                let passedExtraction = props.selectedElement.ranges[selectedRangeIndex]
                finalExtractionType = setPassedExtraction(passedExtraction)
            }

            setSelectedElement(props.selectedElement)
            getRowData(selectedRangeIndex, props.selectedElement, tabData, finalExtractionType["numberOfWords"], finalExtractionType["extractorType"], finalExtractionType["inverse"], finalExtractionType["after"], finalExtractionType["occurrence"], finalExtractionType["regularExpressionTerm"], finalExtractionType["regularExpressionOutput"], finalExtractionType["extractionType"], props.tableHasHeader, props.currentTab, factsColumnRanges)
        }
    }, [props.selectedElement])

    useEffect(() => {
        if (selectedRangeIndex !== props.selectedRangeIndex) {
            let finalExtractionType = null
            if (selectedElement.ranges[props.selectedRangeIndex] === undefined || selectedElement.ranges[props.selectedRangeIndex] === null) {
                finalExtractionType = resetExtraction()
            } else {
                let passedExtraction = selectedElement.ranges[props.selectedRangeIndex]["extractor"]
                finalExtractionType = setPassedExtraction(passedExtraction)
            }

            setSelectedRangeIndex(props.selectedRangeIndex)
            getRowData(props.selectedRangeIndex, selectedElement, tabData, finalExtractionType["numberOfWords"], finalExtractionType["extractorType"], finalExtractionType["inverse"], finalExtractionType["after"], finalExtractionType["occurrence"], finalExtractionType["regularExpressionTerm"], finalExtractionType["regularExpressionOutput"], finalExtractionType["extractionType"], props.tableHasHeader, props.currentTab, factsColumnRanges)
        }
    }, [props.selectedRangeIndex])

    useEffect(() => {
        if (tabData.length !== props.previewData.length) {
            setTabData(props.previewData)
            getRowData(selectedRangeIndex, selectedElement, props.previewData, numberOfWords, extractorType, inverse, after, occurrence, regularExpressionTerm, regularExpressionOutput, dateExtractorType, props.tableHasHeader, currentTab, factsColumnRanges)
        }
    }, [props.previewData])

    useEffect(() => {
        if (props.tableHasHeader !== tableHasHeader) {
            getRowData(selectedRangeIndex, selectedElement, tabData, numberOfWords, extractorType, inverse, after, occurrence, regularExpressionTerm, regularExpressionOutput, dateExtractorType, props.tableHasHeader)
            setTableHasHeader(props.tableHasHeader)
        }
    }, [props.tableHasHeader])

    useEffect(() => {
        if (props.currentTab !== currentTab) {
            getRowData(selectedRangeIndex, selectedElement, tabData, numberOfWords, extractorType, inverse, after, occurrence, regularExpressionTerm, regularExpressionOutput, dateExtractorType, props.tableHasHeader, props.currentTab, props.currentTab)
            setCurrentTab(props.currentTab)
        }
    }, [props.currentTab])

    useEffect(() => {
        if (props.externalTabData.length !== externalTabData.length) {
            setExternalTabData(props.externalTabData)
        }
    }, [props.externalTabData])

    /**
     * getRowData
     * * Compile the data for the row based on the selection
     * @param {int} rangeIndex - Currently selected range
     * @param {Object} item - Selected item
     * @param {Object} data - Preview tabbed data
     * @param {int} words - Number of words to extract
     * @param {string} typeOfExtractor - Extractor type
     * @param {boolean} inverseSelection - Inverse the selection
     * @param {int} afterWords - How many words after this amount to take?
     * @param {string} stringOccurence - Occurence to extract before/after set string
     * @param {string} expressionTerm - Regex expression term
     * @param {string} expressionOutput - Expression output
     * @param {int} dateType - Date type of extraction
     * @param {boolean} hasHeader - Boolean for tables have a header
     * @param {int} tabIndex - Index of the tabs we are looking at
     * @param {Array} factsCols - Facts Column Definitions
    */
    function getRowData(rangeIndex, item, data, words, typeOfExtractor, inverseSelection, afterWords, stringOccurence, expressionTerm, expressionOutput, dateType, hasHeader, tabIndex, factsCols) {
        if (data.length > 0) {
            let factsColumnIndexes = []
            let renderedData = []
            let rangeToGenerate = item["ranges"][rangeIndex]
            
            if (item["type"] === -1) {
                factsColumnIndexes = getFactsRangeIndexes(data[tabIndex]["previewData"], hasHeader, factsCols)
            }
            
            if (rangeToGenerate !== undefined && rangeToGenerate !== null) {
                let colIndexToUse = -20
                let rowIndex = rangeToGenerate["rowIndex"]
                let name = rangeToGenerate["name"]
                let individualCellValue = null
                
                if (name.includes('Sheet:')) {
                    let tabName = extractTabName(name)
                    individualCellValue = getCellValue(tabName, rangeToGenerate, externalTabData)
                    colIndexToUse = rangeToGenerate["colIndex"]
                }
                else if (name.includes('PCell')) {
                    individualCellValue = data[tabIndex]["previewData"][rangeToGenerate["rowIndex"]][rangeToGenerate["colIndex"]]
                }
                else if (rangeIndexIsMinimalValue(rangeToGenerate["colIndex"]) && rangeIndexIsMinimalValue(rangeToGenerate["rowIndex"])) {
                    let nameLookup = name.replace(/^NColumn:/, '')
                    let definitionIndex = getTabsRowOffset(hasHeader, data[tabIndex]["previewData"])
                    
                    for (let x = 0; x < data[tabIndex]["previewData"][definitionIndex].length; x++) {
                        if (data[tabIndex]["previewData"][definitionIndex][x] === nameLookup) {
                            colIndexToUse = x
                        }
                    }
                } else if (rangeToGenerate["colIndex"] > -1) {
                    colIndexToUse = rangeToGenerate["colIndex"]
                }

                if (individualCellValue !== null) {
                    renderedData.push({
                        "value": individualCellValue,
                        "result": processText(
                            individualCellValue,
                            typeOfExtractor,
                            words,
                            inverseSelection,
                            afterWords,
                            stringOccurence, 
                            expressionTerm,
                            expressionOutput,
                            dateType
                        )
                    })
                } else if (rowIndex >= 0) {
                    let offsetIndex = getTabsRowOffset(hasHeader, data[tabIndex]["previewData"]) + rowIndex
                    let rowData = data[tabIndex]["previewData"][offsetIndex]
                    for (let x = 0; x < rowData.length; x++) {
                        if (factsColumnIndexes.length === 0 || factsColumnIndexes.includes(x)) {
                            let stringValue = rangeToGenerate["name"] === "From Table Name" ? data[tabIndex]["tabName"] : rowData[x]
                            renderedData.push({
                                "value": stringValue,
                                "result": processText(
                                    stringValue,
                                    typeOfExtractor,
                                    words,
                                    inverseSelection,
                                    afterWords,
                                    stringOccurence, 
                                    expressionTerm,
                                    expressionOutput,
                                    dateType)
                                })
                        }
                    }
                } else if (colIndexToUse > -20) {
                    let definitionIndex = getTabsRowOffset(hasHeader, data[tabIndex]["previewData"])
                    for (let x = 0; x < data[tabIndex]["previewData"].length; x++) {
                        if (x >= definitionIndex) {
                            let stringValue = rangeToGenerate["name"] === "From Table Name" ? data[tabIndex]["tabName"] : data[tabIndex]["previewData"][x][colIndexToUse]
                            renderedData.push({
                                "value": stringValue,
                                "result": processText(
                                    stringValue,
                                    typeOfExtractor,
                                    words,
                                    inverseSelection,
                                    afterWords,
                                    stringOccurence, 
                                    expressionTerm,
                                    expressionOutput,
                                    dateType
                                )
                            })
                        }
                    }
                } else if (rangeToGenerate["name"] === "From Table Name") {
                    renderedData.push({
                        "value": data[tabIndex]["tabName"],
                        "result": processText(
                            data[tabIndex]["tabName"],
                            typeOfExtractor,
                            words,
                            inverseSelection,
                            afterWords,
                            stringOccurence, 
                            expressionTerm,
                            expressionOutput,
                            dateType)
                        })
                }
            }

            setPreviewData(renderedData)
        } else {
            setPreviewData([])
        }
    }

    function renderExtractor(type) {
        if (type === 'FIRSTWORDS') {
            return <>
                <Typography sx={{ "padding": "15px 0px" }}>Select how you would like to use the first words for extraction</Typography>
                <TextField
                    type="number"
                    fullWidth
                    value={numberOfWords}
                    onChange={(e) => {
                        e.preventDefault()
                        if (e.target.value > 0) {
                            setNumberOfWords(e.target.value)
                            getRowData(selectedRangeIndex, selectedElement, tabData, e.target.value, extractorType, inverse, after, occurrence, regularExpressionTerm, regularExpressionOutput, dateExtractorType, tableHasHeader, currentTab, factsColumnRanges)
                        }
                    }}
                    InputLabelProps={{
                        shrink: true,
                    }}
                    size="small"
                    label="Extract first x words"
                />
                <FormControlLabel
                    sx={{ "padding": "15px 0px" }}
                    control={
                        <Checkbox
                            color="primary"
                            checked={inverse}
                            onChange={(e) => {
                                setInverse(e.target.checked)
                                getRowData(selectedRangeIndex, selectedElement, tabData, numberOfWords, extractorType, e.target.checked, after, occurrence, regularExpressionTerm, regularExpressionOutput, dateExtractorType, tableHasHeader, currentTab, factsColumnRanges)
                            }} />
                    } 
                    label="Inverse extraction" />
            </>
        } else if (type === 'LASTWORDS') {
            return <>
                <Typography sx={{ "padding": "15px 0px" }}>Select how you would like to use the last words for extraction</Typography>
                <TextField
                    type="number"
                    fullWidth
                    value={numberOfWords}
                    onChange={(e) => {
                        e.preventDefault()
                        if (e.target.value > 0) {
                            setNumberOfWords(e.target.value)
                            getRowData(selectedRangeIndex, selectedElement, tabData, e.target.value, extractorType, inverse, after, occurrence, regularExpressionTerm, regularExpressionOutput, dateExtractorType, tableHasHeader, currentTab, factsColumnRanges)
                        }
                    }}
                    InputLabelProps={{
                        shrink: true,
                    }}
                    size="small"
                    label="Extract last x words"
                />
                <FormControlLabel
                    sx={{ "padding": "15px 0px" }}
                    control={
                        <Checkbox
                            color="primary"
                            checked={inverse}
                            onChange={(e) => {
                                setInverse(e.target.checked)
                                getRowData(selectedRangeIndex, selectedElement, tabData, numberOfWords, extractorType, e.target.checked, after, occurrence, regularExpressionTerm, regularExpressionOutput, dateExtractorType, tableHasHeader, currentTab, factsColumnRanges)
                            }} />
                    } 
                    label="Inverse extraction" />
            </>
        } else if (type === 'FIRSTWORDSAFTERFIRSTNUMBEROFWORDS') {
            return <>
                <Typography sx={{ "padding": "15px 0px" }}>Select how you would like to use the x words after the first Y words for extraction</Typography>
                <TextField
                    type="number"
                    fullWidth
                    value={numberOfWords}
                    onChange={(e) => {
                        e.preventDefault()
                        if (e.target.value > 0) {
                            setNumberOfWords(e.target.value)
                            getRowData(selectedRangeIndex, selectedElement, tabData, e.target.value, extractorType, inverse, after, occurrence, regularExpressionTerm, regularExpressionOutput, dateExtractorType, tableHasHeader, currentTab, factsColumnRanges)
                        }
                    }}
                    InputLabelProps={{
                        shrink: true,
                    }}
                    size="small"
                    label="Extract"
                />
                <Typography>words after the first</Typography>
                <TextField
                    type="number"
                    fullWidth
                    value={after}
                    onChange={(e) => {
                        e.preventDefault()
                        if (e.target.value > 0) {
                            setAfter(e.target.value)
                            getRowData(selectedRangeIndex, selectedElement, tabData, numberOfWords, extractorType, inverse, e.target.value, occurrence, regularExpressionTerm, regularExpressionOutput, dateExtractorType, tableHasHeader, currentTab, factsColumnRanges)
                        }
                    }}
                    InputLabelProps={{
                        shrink: true,
                    }}
                    size="small"
                    label="Words"
                />
                <FormControlLabel
                    sx={{ "padding": "15px 0px" }}
                    control={
                        <Checkbox
                            color="primary"
                            checked={inverse}
                            onChange={(e) => {
                                setInverse(e.target.checked)
                                getRowData(selectedRangeIndex, selectedElement, tabData, numberOfWords, extractorType, e.target.checked, after, occurrence, regularExpressionTerm, regularExpressionOutput, dateExtractorType, tableHasHeader, currentTab, factsColumnRanges)
                            }} />
                    } 
                    label="Inverse extraction" />
            </>
        } else if (type === 'FIRSTWORDSAFTERLASTNUMBEROFWORDS') {
            return <>
                <Typography sx={{ "padding": "15px 0px" }}>Select how you would like to use the x words after the first Y words for extraction</Typography>
                <TextField
                    type="number"
                    fullWidth
                    value={numberOfWords}
                    onChange={(e) => {
                        e.preventDefault()
                        if (e.target.value > 0) {
                            setNumberOfWords(e.target.value)
                            getRowData(selectedRangeIndex, selectedElement, tabData, e.target.value, extractorType, inverse, after, occurrence, regularExpressionTerm, regularExpressionOutput, dateExtractorType, tableHasHeader, currentTab, factsColumnRanges)
                        }
                    }}
                    InputLabelProps={{
                        shrink: true,
                    }}
                    size="small"
                    label="Extract"
                />
                <Typography>words after the last</Typography>
                <TextField
                    type="number"
                    fullWidth
                    value={after}
                    onChange={(e) => {
                        e.preventDefault()
                        if (e.target.value > 0) {
                            setAfter(e.target.value)
                            getRowData(selectedRangeIndex, selectedElement, tabData, numberOfWords, extractorType, inverse, e.target.value, occurrence, regularExpressionTerm, regularExpressionOutput, dateExtractorType, tableHasHeader, currentTab, factsColumnRanges)
                        }
                    }}
                    InputLabelProps={{
                        shrink: true,
                    }}
                    size="small"
                    label="Words"
                />
                <FormControlLabel
                    sx={{ "padding": "15px 0px" }}
                    control={
                        <Checkbox
                            color="primary"
                            checked={inverse}
                            onChange={(e) => {
                                setInverse(e.target.checked)
                                getRowData(selectedRangeIndex, selectedElement, tabData, numberOfWords, extractorType, e.target.checked, after, occurrence, regularExpressionTerm, regularExpressionOutput, dateExtractorType, tableHasHeader, currentTab, factsColumnRanges)
                            }} />
                    } 
                    label="Inverse extraction" />
            </>
        } else if (type === 'FIRSTWORDSBEFOREOCCURRENCE') {
            return <>
                <Typography sx={{ "padding": "15px 0px" }}>Select how you would like to use the X words after the first Y words for extraction</Typography>
                <TextField
                    type="number"
                    fullWidth
                    value={numberOfWords}
                    onChange={(e) => {
                        e.preventDefault()
                        if (e.target.value > 0) {
                            setNumberOfWords(e.target.value)
                            getRowData(selectedRangeIndex, selectedElement, tabData, e.target.value, extractorType, inverse, after, occurrence, regularExpressionTerm, regularExpressionOutput, dateExtractorType, tableHasHeader, currentTab, factsColumnRanges)
                        }
                    }}
                    InputLabelProps={{
                    shrink: true,
                    }}
                    size="small"
                    label="Extract"
                />
                <Typography>words before the first occurrence of</Typography>
                <TextField
                    fullWidth
                    value={occurrence}
                    onChange={(e) => {
                        e.preventDefault()
                        setOccurrence(e.target.value)
                        getRowData(selectedRangeIndex, selectedElement, tabData, numberOfWords, extractorType, inverse, after, e.target.value, regularExpressionTerm, regularExpressionOutput, dateExtractorType, tableHasHeader, currentTab, factsColumnRanges)
                    }}
                    size="small"
                />
                <FormControlLabel
                    sx={{ "padding": "15px 0px" }}
                    control={
                        <Checkbox
                            color="primary"
                            checked={inverse}
                            onChange={(e) => {
                                setInverse(e.target.checked)
                                getRowData(selectedRangeIndex, selectedElement, tabData, numberOfWords, extractorType, e.target.checked, after, occurrence, regularExpressionTerm, regularExpressionOutput, dateExtractorType, tableHasHeader, currentTab, factsColumnRanges)
                            }} />
                    } 
                    label="Inverse extraction" />
            </>
        } else if (type === 'REGULAREXPRESSION') {
            return <>
                <Typography sx={{ "padding": "15px 0px" }}>Enter a regular expression with capturing groups and set the formatting for those capturing groups.</Typography>
                <FormGroup row>
                    <TextField
                        value={regularExpressionTerm}
                        onChange={(e) => {
                            e.preventDefault()
                            setRegularExpressionTerm(e.target.value)

                            let newOutputFormat = getNewOutputFormat(e.target.value)
                            if (newOutputFormat) {
                                setRegularExpressionOutput(newOutputFormat)
                            } else {
                                newOutputFormat = regularExpressionOutput
                            }
                            getRowData(selectedRangeIndex, selectedElement, tabData, numberOfWords, extractorType, inverse, after, occurrence, e.target.value, newOutputFormat, dateExtractorType, tableHasHeader, currentTab, factsColumnRanges)
                        }}
                        size="small"
                        id="regular-expression"
                        label="Regular expression"
                    />
                    <IconButton aria-label="Add Segment" size="small" onClick={(e) => {
                        e.preventDefault()

                        if (isValidRegex(regularExpressionTerm)) {
                            alert("Valid Regular Expression")
                        } else {
                            alert("Invalid Regular Expression")
                        }
                    }}>
                        <CheckIcon fontSize="inherit" />
                    </IconButton>
                    <FormControl size="small" sx={{ "width": "200px" }}>
                        <InputLabel htmlFor="regex-select">RegEx Selection</InputLabel>
                        <Select defaultValue="" id="regex-select" label="RegEx Selection" onChange={(e) => {
                            e.preventDefault()
                            
                            let copiedRegularExpressionTerm = regularExpressionTerm
                            copiedRegularExpressionTerm += e.target.value
                            setRegularExpressionTerm(copiedRegularExpressionTerm)
                            getRowData(selectedRangeIndex, selectedElement, tabData, numberOfWords, extractorType, inverse, after, occurrence, copiedRegularExpressionTerm, regularExpressionOutput, dateExtractorType, tableHasHeader, currentTab, factsColumnRanges)
                        }}>
                            <MenuItem value="">
                                <em>None</em>
                            </MenuItem>
                            <ListSubheader>Character Classes</ListSubheader>
                            <MenuItem value={'.'}>. - Any character</MenuItem>
                            <MenuItem value={'\\w'}>\w - Word character</MenuItem>
                            <MenuItem value={'\\W'}>\W - Non-word character</MenuItem>
                            <MenuItem value={'\\s'}>\s - White space</MenuItem>
                            <MenuItem value={'\\S'}>\s - Non-white space</MenuItem>
                            <MenuItem value={'\\d'}>\d - Decimal digit</MenuItem>
                            <MenuItem value={'\\D'}>\D - Not a decimal digit</MenuItem>
                            <MenuItem value={'[<chars>]'}>[&lt;chars&gt;] Character class</MenuItem>
                            <MenuItem value={'[^<chars>]'}>[^&lt;chars&gt;] Negated character classes</MenuItem>
                            <ListSubheader>Quantifiers</ListSubheader>
                            <MenuItem value={'*'}>* - Zero or more</MenuItem>
                            <MenuItem value={'+'}>+ - One or more</MenuItem>
                            <MenuItem value={'?'}>? - Zero or one</MenuItem>
                            <MenuItem value={'{<n>}'}>&#123;&lt;n&gt;&#125; - Exactly n</MenuItem>
                            <MenuItem value={'{<n>,<m>}'}>&#123;&lt;n&gt;,&lt;m&gt;&#125; - From n to m</MenuItem>
                            <MenuItem value={'{<n>,}'}>&#123;&lt;n,&gt;&#125; - At least n</MenuItem>
                            <MenuItem value={'*?'}>*? - Zero or more non greedy</MenuItem>
                            <MenuItem value={'+?'}>+? - One or more non greedy</MenuItem>
                            <MenuItem value={'??'}>?? - Zero or one non greedy</MenuItem>
                            <MenuItem value={'{<n>}?'}>&#123;&lt;n&gt;&#125;? - Exactly n non greedy</MenuItem>
                            <MenuItem value={'{<n>,<m>}?'}>&#123;&lt;n&gt;,&lt;m&gt;&#125;? - From n to m non greedy</MenuItem>
                            <MenuItem value={'{<n>,}?'}>&#123;&lt;n,&gt;&#125;? - At least n non greedy</MenuItem>
                            <ListSubheader>Quantifiers</ListSubheader>
                            <MenuItem value={'^'}>^ - Beginning of string</MenuItem>
                            <MenuItem value={'$'}>$ - End of string</MenuItem>
                            <MenuItem value={'\\b'}>\b - Word boundary</MenuItem>
                            <MenuItem value={'\\B'}>\b - Not a word boundary</MenuItem>
                            <ListSubheader>Grouping</ListSubheader>
                            <MenuItem value={'<exp>'}>&lt;exp&gt; - Capture</MenuItem>
                            <MenuItem value={'(?<<name>><exp>)'}>(?&lt;&lt;name&gt;&gt;&lt;exp&gt;) - Named capture</MenuItem>
                            <MenuItem value={'(?:<exp>)'}>(?:&lt;exp&gt;) - Non-capture</MenuItem>
                            <MenuItem value={'(<x>|<y>)'}>(&lt;x&gt;|&lt;y&gt;) - Alernation</MenuItem>
                            <ListSubheader>Zero-Width</ListSubheader>
                            <MenuItem value={'(?=<x>)'}>(?=&lt;x&gt;) - Positive lookahead</MenuItem>
                            <MenuItem value={'(?!<x>)'}>(?!&lt;x&gt;) - Negative lookahead</MenuItem>
                            <MenuItem value={'(?<<x>)'}>(?&lt;&lt;x&gt;) - Positive lookbehind</MenuItem>
                            <MenuItem value={'(?<!<x>)'}>(?&lt;!&lt;x&gt;) - Negative lookbehind</MenuItem>
                            <ListSubheader>Conditionals</ListSubheader>
                            <MenuItem value={'(?(<exp>)yes|no)'}>(?(&lt;exp&gt;)yes|no) - Expression</MenuItem>
                            <MenuItem value={'(?(<name>)yes|no)'}>(?(&lt;name&gt;)yes|no) - Named</MenuItem>
                            <ListSubheader>Options</ListSubheader>
                            <MenuItem value={'(?i)'}>(?i) - Ignore case</MenuItem>
                            <MenuItem value={'(?-i)'}>(?-i) - Ignore case OFF</MenuItem>
                            <MenuItem value={'(?c)'}>(?c) - Explicit capture</MenuItem>
                            <MenuItem value={'(?-c)'}>(?-c) - Explicit capture OFF</MenuItem>
                            <MenuItem value={'(?x)'}>(?x) - Ignore whote space</MenuItem>
                            <MenuItem value={'(?-x)'}>(?-x) - Ignore whote space OFF</MenuItem>
                        </Select>
                    </FormControl>
                </FormGroup>
                <TextField
                    value={regularExpressionOutput}
                    fullWidth
                    onChange={(e) => {
                        e.preventDefault()
                        setRegularExpressionOutput(e.target.value)
                        getRowData(selectedRangeIndex, selectedElement, tabData, numberOfWords, extractorType, inverse, after, occurrence, regularExpressionTerm, e.target.value, dateExtractorType, tableHasHeader, currentTab, factsColumnRanges)
                    }}
                    size="small"
                    id="regular-expression-output"
                    label="Regular expression output"
                    sx={{ "margin": "5px 0px" }} />
            </>
        } else if (type === 'ENDDATE') {
            return <>
                <Select defaultValue="" id="regex-select" value={dateExtractorType} label="RegEx Selection" onChange={(e) => {
                    e.preventDefault()
                    setDateExtractorType(e.target.value)
                    getRowData(selectedRangeIndex, selectedElement, tabData, numberOfWords, extractorType, inverse, after, occurrence, regularExpressionTerm, regularExpressionOutput, e.target.value, tableHasHeader, currentTab, factsColumnRanges)
                }}>
                    <MenuItem value={0}>Year</MenuItem>
                    <MenuItem value={1}>Month</MenuItem>
                    <MenuItem value={2}>Day</MenuItem>
                    <MenuItem value={3}>Year/Month/Day</MenuItem>
                </Select>
            </>
        }

        return null
    }

    function processText(text, type, words, inverseSelection, afterWords, stringOccurence, expressionTerm, expressionOutput, dateType) {
        if (type === 'FIRSTWORDS') {
            return processFirstWordsText(text, words, inverseSelection)
        } else if (type === 'LASTWORDS') {
            return processLastWordsText(text, words, inverseSelection)
        } else if (type === 'FIRSTWORDSAFTERFIRSTNUMBEROFWORDS') {
            return processFirstWordsAfterFirstNumberOfWordsText(text, words, inverseSelection, afterWords)
        } else if (type === 'FIRSTWORDSAFTERLASTNUMBEROFWORDS') {
            return processFirstWordsAfterLastNumberOfWordsText(text, words, inverseSelection, afterWords)
        } else if (type === 'FIRSTWORDSBEFOREOCCURRENCE') {
            return processFirstWordsBeforeOccurence(text, words, inverseSelection, stringOccurence)
        } else if (type === 'REGULAREXPRESSION') {
            return processRegularExpressionText(text, expressionTerm, expressionOutput)
        } else if (type === 'ENDDATE') {
            processDateExpression(text, dateType)
        }

        return text
    }

    function isValidRegex(str) {
        try {
            new RegExp(str);
            return true;
        } catch (e) {
            return false;
        }
    }

    function setPassedExtraction(passedExtraction) {
        setExtractorType(passedExtraction["extractorType"])
        setNumberOfWords(passedExtraction["numberOfWords"])
        setAfter(passedExtraction["after"])
        setInverse(passedExtraction["inverse"])
        setOccurrence(passedExtraction["occurrence"])
        setRegularExpressionTerm(passedExtraction["regularExpressionTerm"])
        setRegularExpressionOutput(passedExtraction["regularExpressionOutput"])
        setDateExtractorType(passedExtraction["extractionType"])
        return passedExtraction
    }

    function resetExtraction() {
        setExtractorType('NONE')
        setNumberOfWords(1)
        setAfter(1)
        setInverse(false)
        setOccurrence('')
        setRegularExpressionTerm('')
        setRegularExpressionOutput('')
        setDateExtractorType(0)
        return { "extractorType": 'NONE', "numberOfWords": 1, "inverse" : false, "after" : 1, "occurrence": "", "regularExpressionTerm": "", "regularExpressionOutput": "", "extractionType": 0 }
    }

    function extractTabName(rangeName) {
        const pattern = /Sheet:(.*?)!/
        let result = rangeName.match(pattern)[1]
        return result
    }

    function getCellValue(tabName, rangeData, externalTabsData) {
        for (let x = 0; x < externalTabsData.length; x++) {
            if (externalTabsData[x]["tabName"] === tabName) {
                return externalTabsData[x]["previewData"][rangeData.rowIndex][rangeData.colIndex]
            }
        }
    }

    function rangeIndexIsMinimalValue(index) {
        return index === -20 || index === -2147483648
    }

    /**
     * getTabsRowOffset
     * * 
     * @param {boolean} hasHeader - Do the tables have a header? 
     * @param {Array} tabPreviewData - Preview data from the source 
     * @returns {int} First row header
     */
    function getTabsRowOffset(hasHeader, tabPreviewData) {
        // Only run this if we determine the table has a header
        if (hasHeader) {
            for (let x = 0; x < tabPreviewData.length; x++) {
                if (props.doesThisRowHaveDataInEverySingleColumn(tabPreviewData[x])) {
                    return x
                }
            }
        }

        return 0
    }

    /**
     * getColumnIndexFromName
     * * Looks up the exact column index from the column name
     * @param {int} headingRow - Row index that represents the header 
     * @param {Array} data - Preview data from the source 
     * @param {string} columName - Name of column, usually in the format of [NColumn:{Any name}] 
     * @returns 
     */
    function getColumnIndexFromName(headingRow, data, columName) {
        let rtnVal = -20
        let processedColumnName = columName.replace('NColumn:', '')
        for (let x = 0; x < data[headingRow].length; x++) {
            if (processedColumnName === data[headingRow][x]) {
                rtnVal = x
            }
        }

        return rtnVal
    }

    /**
     * getFactsRangeIndexes
     * * Generate the indexes of each column we need to get if we are dealing with measures
     * @param {Object} data - Preview tabbed data
     * @param {boolean} hasHeader - Boolean for tables have a header
     * @param {Array} factsCols - Facts Column Definitions
     * @returns {Array} - Column Indexes
    */
    function getFactsRangeIndexes(data, hasHeader, factsCols) {
        let offset = getTabsRowOffset(hasHeader, data)
        let rtnVal = []

        for (let x = 0; x < factsCols.length; x++) {
            if (!factsCols[x]["absolute"]) {
                let newColIndex = getColumnIndexFromName(offset, data, factsCols[x]["name"])
                rtnVal.push(newColIndex)
            } else if (factsCols[x]["leftIsAnchored"] && factsCols[x]["rightIsAnchored"]) {
                for (let definitionIndex = factsCols[x]["left"]; definitionIndex <= factsCols[x]["right"]; definitionIndex++) {
                    rtnVal.push(definitionIndex)
                }
            }  else if  (factsCols[x]["leftIsAnchored"]) {
                let anchor = factsCols[x]["left"]
                let width = factsCols[x]["right"] - factsCols[x]["left"]
                let itr = 0
                
                while (itr <= width) {
                    rtnVal.push(anchor)
                    anchor++
                    itr++
                }
            } else {
                let rAnchor = factsCols[x]["tableWidth"] - factsCols[x]["right"]
                let width = factsCols[x]["right"] - factsCols[x]["left"] + 1
                let itr = 0
                
                while (itr < width) {
                    rtnVal.push(rAnchor)
                    rAnchor--
                    itr++
                }
            }
        }

        return rtnVal
    }

    return <Dialog open={open} maxWidth="lg" fullWidth>
        <CloseIcon onClick={(e) => {
            e.preventDefault()
            
            // Fire off external onClose
            if (props.onClose) {
                props.onClose()
            }
        }} className="closePoup" />
        <DialogTitle>Series Source Properties</DialogTitle>
        <DialogContent>
            <DialogContentText>Select an extraction for the selected source and whether nulls should be used.</DialogContentText>
            <Grid container spacing={2}>
                <Grid item xs={6} sx={{ "display": "flex", "justifyContent": "center", "alignItems": "center" }}>
                    <FormControl className="field" fullWidth>
                        <InputLabel id="extraction-label">Extraction</InputLabel>
                        <Select
                            label="Extraction"
                            labelId="extraction-label"
                            id="extraction"
                            onChange={(e) => {
                                e.preventDefault()
                                setExtractorType(e.target.value)
                                getRowData(selectedRangeIndex, selectedElement, tabData, numberOfWords, e.target.value, inverse, after, occurrence, regularExpressionTerm, regularExpressionOutput, dateExtractorType, tableHasHeader, currentTab, factsColumnRanges)
                            }}
                            fullWidth
                            value={extractorType}
                        >
                            <MenuItem value={'NONE'}>None</MenuItem>
                            <MenuItem value={'FIRSTWORDS'}>Using first X words</MenuItem>
                            <MenuItem value={'LASTWORDS'}>Using last X words</MenuItem>
                            <MenuItem value={'FIRSTWORDSAFTERFIRSTNUMBEROFWORDS'}>Using X words after first Y words</MenuItem>
                            <MenuItem value={'FIRSTWORDSAFTERLASTNUMBEROFWORDS'}>Using X words before last Y words</MenuItem>
                            <MenuItem value={'FIRSTWORDSBEFOREOCCURRENCE'}>Using X words before first occurrence of Z</MenuItem>
                            <MenuItem value={'REGULAREXPRESSION'}>Custom regular expression</MenuItem>
                            <MenuItem value={'ENDDATE'}>Extract the end date from a date range</MenuItem>
                        </Select>
                    </FormControl>
                </Grid>
                <Grid item xs={6} sx={{ "display": "flex", "flexDirection": "column", "justifyContent": "center", "alignItems": "start" }}>
                    {renderExtractor(extractorType)}
                </Grid>
            </Grid>
            <TableContainer component={Paper} sx={{ "maxHeight": "350px", "overflowY": "scroll" }}>
                <Table aria-label="preview data">
                    <TableHead>
                        <TableRow>
                            <TableCell></TableCell>
                            <TableCell>Value</TableCell>
                            <TableCell>Result</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {previewData.map((preview, pIndex) => {
                            return <TableRow key={`preview-data-row-${pIndex}`}>
                                <TableCell>{pIndex+1}</TableCell>
                                <TableCell>{preview["value"]}</TableCell>
                                <TableCell>{preview["result"]}</TableCell>
                            </TableRow>
                        })}
                    </TableBody>
                </Table>
            </TableContainer>
        </DialogContent>
        <DialogActions disableSpacing={false} style={{ justifyContent: "center" }}>
            <Button className="btn" variant="contained" disabled={false} onClick={(e) => {
                if (props.onSave) {
                    props.onSave({ "extractorType": extractorType, "numberOfWords": numberOfWords, "inverse" : inverse, "after" : after, "occurrence": occurrence, "regularExpressionTerm": regularExpressionTerm, "regularExpressionOutput": regularExpressionOutput, "extractionType": dateExtractorType })
                }

                if (props.onClose) {
                    props.onClose()
                }
            }}>
                OK
            </Button>
            <Button className="btn" variant="contained" disabled={false} onClick={(e) => {
                resetExtraction()
                getRowData(selectedRangeIndex, selectedElement, tabData, 1, "NONE", false, 1, "", "", "", 0, tableHasHeader, currentTab, factsColumnRanges)
                
                if (props.onClose) {
                    props.onClose()
                }
            }}>
                Cancel
            </Button>
        </DialogActions>
    </Dialog>
}

export default SourcePropertiesWizard